import ReactGA from 'react-ga';

const getTrackingCode = () => {
  switch (process.env.REACT_APP_CURRENT_RUNNING_ENVIRONMENT) {
    case 'uat1':
      return 'UA-167846316-3';
    case 'prod':
      return 'UA-167846316-1';
    default:
      return null;
  }
};

const trackingCode = getTrackingCode();

if (trackingCode) {
  ReactGA.initialize(trackingCode);
}
